var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
var Context = createContext(null);
export var ShowDetailsProvider = function (_a) {
    var children = _a.children;
    var _b = useState(false), show = _b[0], setShow = _b[1];
    var toggleShow = function () {
        setShow(function (s) { return !s; });
    };
    var setVisible = function () {
        setShow(true);
    };
    var setHidden = function () {
        setShow(false);
    };
    return _jsx(Context.Provider, __assign({ value: { show: show, setShow: setShow, toggleShow: toggleShow, setVisible: setVisible, setHidden: setHidden } }, { children: children }));
};
export var useShowDetails = function () {
    var context = useContext(Context);
    if (!context)
        throw new Error('ShowDetailsProvider not found in root');
    return context;
};
//# sourceMappingURL=ShowDetails.js.map